import countries from './countries';
import messages from './messages';

const en = {
  ...countries,
  ...messages,
};

export default en;